import { createUseStyles } from 'react-jss';

import { color, fontSize, spacing } from '../../variables';

export const useButtonOutlineStyles = createUseStyles({
    overlay: {
        position: 'relative',
    },
    root: {
        fontSize: fontSize.md,
        color: color.content.primary,
        fontWeight: 600,
        background: 'transparent',
        borderRadius: 4,
        border: `1px solid transparent`,
        letterSpacing: -0.42,
        padding: spacing['04'],
        boxShadow: 'none',

        '&:hover': {
            border: `1px solid ${color.border.opaque} !important`,
            background: `${color.background.secondary} !important`,
            transition: 'all 0.5s',
        },

        '&:disabled': {
            background: color.background.disabled,
            borderColor: `${color.border.inverseOpaque} !important`,
            color: `${color.content.stateDisable} !important`,
        },
    },
});
